import { Component, OnInit } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { AddPlayer } from './addPlayer';
import { NgwService } from '../../app/ngw.service';
import { NgwPlayer, NgwGame } from '../../app/classes/ngwGame';
import { TabsPage } from '../tabs/tabs';


@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
  styles: [
    '.logo { width: 100px; height: 100px; background-repeat: no-repeat; background-position: 50% 50%; float: left; }',
    '.logoAt {width: 20px; height: 100px; float: left; line-height: 100px }'
  ]
})
export class SettingsPage implements OnInit {
  ngwPlayers: NgwPlayer[];
  currGame: NgwGame = null;
  isCreating = false;


  constructor(public navCtrl: NavController, public modalCtrl: ModalController, public ngwService: NgwService, public navParams: NavParams) {

    this.isCreating = this.navParams.get('isCreating');
    console.log("isCreating", this.isCreating)
  }


  ngOnInit(): void {

    this.currGame = this.ngwService.currentGame;
    this.ngwService.getPlayers().then((players: NgwPlayer[]) => {
      this.ngwPlayers = players.sort(function(a, b){
            if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
            if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
            return 0;
        })
      this.ngwPlayers.forEach((player) => {
        player.selected = false
        var listPlayer = this.currGame.players.find((lP) => lP.name == player.name);
        if (listPlayer && !listPlayer.removed)
          player.selected = true;

      });

    });
  }

  getPlayers() {

    if (this.ngwPlayers) {
      this.ngwPlayers.filter((player) => !player.deleted).sort(function (a: NgwPlayer, b: NgwPlayer): number {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      })
    }

    return this.ngwPlayers;
  }

  clicked(ngwPlayer: NgwPlayer) {


    ngwPlayer.selected = !ngwPlayer.selected;
    let gamePlayer = this.currGame.players.find((player: NgwPlayer) => player.name == ngwPlayer.name);
    if (!ngwPlayer.selected) {
      if (gamePlayer)
        gamePlayer.removed = true;
      //this.currGame.players = this.currGame.players.filter(obj => obj.name != ngwPlayer.name);
    }
    else //add them
    {
      let playerCopy: NgwPlayer = Object.assign({}, ngwPlayer);// Object.assign({},obj1);
      playerCopy.balance = 0;
      playerCopy.removed = false;

      if (gamePlayer)
        gamePlayer.removed = false;
      else
        this.currGame.players.push(playerCopy);

      //Now, add them to every round's player list
      this.currGame.rounds.forEach((round) => {
        if(round && round.playerOrder)
        {
          let roundPlayer = round.playerOrder.find((player: NgwPlayer) => player.name == ngwPlayer.name);
          if (roundPlayer)
            roundPlayer.removed = false;
          else
            round.playerOrder.push(playerCopy);
        }
      });

    }

    this.ngwService.updateCurrGame();

    console.log("currGame.players", this.currGame.players);
  }

  newPlayerClicked() {
    let newPlayerModal = this.modalCtrl.create(AddPlayer, { userId: 8675309 });
    newPlayerModal.onDidDismiss(data => {
      if (data.name) {
        let player: NgwPlayer = {
          name: data.name
        };
        this.ngwService.addPlayer(player);
        this.clicked(player);

        //this.ngwPlayers.push(player);
      }
    });

    newPlayerModal.present();
  }

  removePlayer(player: NgwPlayer) {
    player.deleted = true;
    this.ngwService.savePlayers();

    let gamePlayer = this.currGame.players.find((lPlayer: NgwPlayer) => lPlayer.name == player.name);
    if (gamePlayer)
      gamePlayer.removed = true;

    this.ngwService.updateCurrGame();

  }

  createGame() {
    //Now, re-randomize every round's player list
    this.currGame.rounds.forEach((round) => {
      this.ngwService.shuffleRoundPlayers(round);
    });
    this.ngwService.updateCurrGame();

    this.navCtrl.setRoot(TabsPage);
  }

}





// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts